import { createContext, useContext } from 'react'

export interface AppStateProps {
    phoneNumber: string
    isAuthenticated: boolean
    progress: number
    verificationCode: string
    setIsAuthenticated: (value: boolean) => void
    setVerificationCode: (value: string) => void
    setProgress: (value: number) => void
    setPhoneNumber: (value: string) => void
}

const AppContext = createContext<AppStateProps | null>({
    phoneNumber: '',
    isAuthenticated: false,
    progress: 0,
    verificationCode: '',
    setVerificationCode: () => {
        throw new Error('setVerificationCode() not implemented')
    },
    setPhoneNumber: () => {
        throw new Error('setPhoneNumber() not implemented')
    },
    setProgress: () => {
        throw new Error('setProgress() not implemented')
    },
    setIsAuthenticated: () => {
        throw new Error('setIsAuthenticated() not implemented')
    },
})

export const useAppStore = () => {
    const ctx = useContext(AppContext)

    if (!ctx) {
        throw new Error('AppContext can be used only within AppProvider')
    }
    return ctx
}

export default AppContext
